export default "__VITE_ASSET__BfRG2qV___"